import { Col, Row } from 'antd'

import React, { useState } from 'react'
import {
  BoldFontHead,
  CustomDiver,
  InfoSection,
  LeftSideBox,
  ParameterText,
  SubTextTitle,
} from './style'

import Flex from 'components/Flex'
import RoundedDownIcon from 'components/icons/RoundedDownIcon'
import { StyledEditBox1 } from 'modules/InterviewerDashboard/Partials/style'
import { EmptyElement } from '../../../../../../components/UIComponents/CommonStyledDiv'

const Parameters = ({ item, index }) => {
  const [show, setShow] = useState(false)

  return (
    <>
      <Flex alignVertically>
        <InfoSection>
          <BoldFontHead>Round {index + 1}</BoldFontHead>
          <SubTextTitle padTop={true}>{item?.name}</SubTextTitle>
        </InfoSection>

        <LeftSideBox>
          <Flex>
            <StyledEditBox1>
              {Number(item?.averageScore)?.toFixed(2)}
            </StyledEditBox1>
            <EmptyElement
              style={{ padding: '6px 10px 0px 20px' }}
              onClick={() => setShow(!show)}
            >
              <RoundedDownIcon />
            </EmptyElement>
          </Flex>
        </LeftSideBox>
      </Flex>
      <br></br>

      {show &&
        item?.parameters?.map((data, index) => (
          <Row style={{ padding: '10px' }} key={index + data?.name}>
            <Col span={12}>
              <ParameterText>{data?.name}</ParameterText>
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              <ParameterText>{data?.score}</ParameterText>
            </Col>
          </Row>
        ))}
      <CustomDiver />
    </>
  )
}

export default Parameters
